import { useSelector } from 'react-redux'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'

import AppDownloadBanner from '@/components/AppDownloadBanner'
import { NavigationScroll } from '@/components/layout/NavigationScroll'
import OfflineBanner from '@/components/OfflineBanner'

import { useMutationQueueSync } from './offline/useMutationQueueSync'
import Routes from './routes/Routes'
import ReloadPrompt from './ReloadPrompt'
import { RootState } from './store'
import { theme } from './themes'

const App: React.FC = () => {
  const { mode } = useSelector((state: RootState) => state.appSlice)
  const appTheme = theme(mode)

  useMutationQueueSync()

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <OfflineBanner />
      <ReloadPrompt />
      <NavigationScroll>
        <Routes />
      </NavigationScroll>
      <AppDownloadBanner />
    </ThemeProvider>
  )
}

export default App
